import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Redirect } from 'react-router-dom';
import { clearLocalStorage, setLocalStorage } from '../../../utils/storageUtil';
import EditScheme from './EditScheme';
import { formikHandleChange } from '../../../utils/commonUtil';
import { LANDING_INFO, PRELIMINARY_INFO, REQUEST_NUMBER } from '../../../constants/config';
import Loader from '../../../components/shared/Loader';
import { getSchemeInfo } from './services';
import Modal from 'react-bootstrap/Modal';

const Edit = (props) => {
  const { history, requestDraftDetailBasicInfo } = props;
  const [spinner, setSpinner] = useState(false);

  const handleCheckboxChange = (event, setFieldValue) => {
    const targetValue = event.target.checked;
    if (targetValue) {
      setBtnClass('btn-green');
    } else {
      setBtnClass('btn-white');
    }
    setFieldValue(event.target.id, targetValue);
  };

  const btn = document.getElementById('myBtn');
  clearLocalStorage('OtpVerified');

  let className = 'btn btn-primary btn-width ';
  const [btnClass, setBtnClass] = useState('btn-green');
  className += btnClass;

  const [trackingNumber, setTrackingNumber] = useState();
  const [toNext, setToNext] = useState(false);
  const [trackingError, setTrackingError] = useState('');
  const [nrn, setNRN] = useState(false);
  // const [applyCountry, setApplyCountry] = useState(false);
  const [scheme, setScheme] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const onClose = () => {
    setModalVisible(false);
  };

  const onOk = async () => {
    onClose();
  };

  useEffect(() => {
    const params = { isNrn: nrn };
    //toogleValue button (applyCountry) true & false
    //false = insideCountry && true = outsideCountry
    // if (applyCountry) {
    //   params.outsideCountry = true;
    // } else {
    //   params.insideCountry = true;
    // }
    getSchemeInfo(params)
      .then((res) => {
        setScheme(res?.data?.data?.list);
      })
      .catch((err) => {
        setScheme([]);
      });
    // [nrn, applyCountry]
  }, [nrn]);

  return (
    <>
      {spinner ? (
        <Loader />
      ) : (
        <div className="container-fluid home-page">
          <div className="row ml-3">
            <h3 style={{ color: '#0f428a' }}>Online Account Opening</h3>
          </div>
          <Formik
            validateOnChange={true}
            isValidating={true}
            initialValues={{
              tracker: '',
            }}
            validationSchema={Yup.object().shape({
              tracker: Yup.string()
                .trim()
                .required('please enter track number.')
                .min(10, 'please enter at least 10 characters.')
                .max(10, 'please enter max 10 characters.'),
            })}
            onSubmit={(values) => {
              setLocalStorage(REQUEST_NUMBER, trackingNumber);
              btn.disabled = true;
              setSpinner(true);
              setTimeout(() => {
                btn.disabled = false;
                delete values?.tracker;
                requestDraftDetailBasicInfo(trackingNumber)
                  .then((res) => {
                    setSpinner(false);
                    history.push({
                      pathname: `/track-otp-verification`,
                    });
                  })
                  .catch((err) => {
                    if (err) {
                      setSpinner(false);
                      setTrackingError(err?.response?.data?.message);
                      setModalVisible(true);
                    }
                  });
              }, 500);
            }}
          >
            {(formProps) => (
              <>
                {modalVisible ? (
                  <Modal
                    show={onOk}
                    onHide={onClose}
                    centered
                    styles={{
                      modal: { width: '350px', borderRadius: '7px' },
                    }}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Error Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5>
                        {trackingError && <div className="ml-2 error mb-2 ">{trackingError}</div>}
                      </h5>
                    </Modal.Body>
                  </Modal>
                ) : null}
                <Form onSubmit={formProps.handleSubmit}>
                  <div
                    className="row mb-3 mr-0"
                    style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                  >
                    <span className={'mb-2 label'}>Start From Where You Left:</span>
                    <div className="mb-2">
                      <input
                        className=" tracker ml-2"
                        name="tracker"
                        id="tracker"
                        style={{
                          borderRadius: '10px',
                          padding: '5px',
                          color: 'black',
                          width: '300px',
                        }}
                        onChange={(e) => {
                          formikHandleChange(e, formProps.setFieldValue, setBtnClass);
                          setTrackingNumber(e.target.value);
                          setTrackingError('');
                        }}
                        placeholder="Please enter your reference  number"
                      />
                      <button
                        id="myBtn"
                        type="submit"
                        className="btn btn-primary btn-width ml-2"
                        // style={{}}
                        // onClick={handelTrackSubmit}
                      >
                        Submit
                      </button>
                      {formProps.touched?.tracker && formProps.errors?.tracker ? (
                        <div className="ml-2 error ">{formProps.errors?.tracker}</div>
                      ) : null}
                    </div>
                  </div>
                </Form>
              </>
            )}
          </Formik>

          <Formik
            initialValues={{
              existing_account: false,
              applyingCountry: false,
              nrn: false,
              branchName: '',
              accountScheme: '',
              accountType: 'Individual',
              country: '',
              schemeName: '',
            }}
            validationSchema={Yup.object().shape({
              // accountScheme: Yup.string().required('Please select account scheme'),
              branchName: Yup.string().required('Please select branch'),
              country: Yup.string().test(
                'match',
                'Please select country you are applying from.',
                function (val) {
                  return this.from[0].value?.applyingCountry === true
                    ? Yup.string()
                        .required('Please select country you are applying from.')
                        .isValidSync(val)
                    : true;
                }
              ),
            })}
            onSubmit={(values) => {
              let formData = { ...values };
              formData.country = values.country || 'NP';
              setToNext(true);
              clearLocalStorage(PRELIMINARY_INFO);
              setLocalStorage(LANDING_INFO, formData);
            }}
          >
            {(formProps) => (
              <Form onSubmit={formProps.handleSubmit} className={'basic-form'}>
                <EditScheme
                  {...props}
                  {...formProps}
                  scheme={scheme}
                  setNRN={setNRN}
                  // setApplyCountry={setApplyCountry}
                  formikHandleChange={formikHandleChange}
                  handleCheckboxChange={handleCheckboxChange}
                  setBtnClass={setBtnClass}
                  className={className}
                  // setGlCode={setGlCode}
                />
                {toNext ? <Redirect to="/preliminary-form" /> : null}
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};

export default Edit;
